import { DataBean } from "../DataBean";

export class SeverityLevels extends DataBean {

  public async getSeverityLevelsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getSeverityLevelsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteSeverityLevels(idseveritylevels: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteSeverityLevels_Number", [idseveritylevels]);
  }

  public async updateSeverityLevels(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.SeverityLevels_updateSeverityLevels_com.orange.finance.processcontract.bean.SeverityLevels",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.SeverityLevels",
        },
      ]
    );
  }
}
